import React from 'react'
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import CallIcon from '@mui/icons-material/Call';
import MailIcon from '@mui/icons-material/Mail';
import LocationPinIcon from '@mui/icons-material/LocationPin';
export default function PrivacyPolicy() {
    return (
        <>
            
            <div className='ms-hero-banner-sec' style={{ paddingTop: '80px' }}>
                <div className="container">
                    <div className='row  align-items-center'>
                        <div className='col-lg-6'>
                             <div className='ms-banner-heading'>  
                                 <span className='ms-takeaways'> Privacy Protection</span>                             
                                <h1 className='fs-1 pt-3 fw-semibold'>Your Privacy Matters</h1>
                                <p className='fw-lighter' style={{ fontSize: '20px' }}>We are committed to protecting your personal information in accordance with applicable laws and regulatory requirements.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container pt-5 term-wrap'>
                <p className='fw-medium pb-3'><strong>Last Updated:</strong> 03/06/2026</p>
                <p className='fw-medium pb-4'>SnapRupee ("Platform") is operated by <strong>Surya Jyoti Leasing and Finance Limited</strong> ("Company", "we", "our", or "us"). We value your privacy and are committed to protecting your personal information in accordance with applicable laws and regulatory requirements.</p>
                <p className='fw-medium pb-4'>By accessing or using our website, you consent to the collection, use, and disclosure of information as described in this Privacy Policy.</p>

                <h3 className=''>1. Information We Collect</h3>
                <p>We may collect the following information:</p>

                <h4 className=''>Personal Information</h4>
                <div className=''>
                    <ul>
                        <li>Full Name</li>
                        <li>Mobile Number</li>
                        <li>Email Address</li>
                        <li>Date of Birth</li>
                        <li>Residential Address</li>
                    </ul>
                </div>

                <h4 className=''>Identity & Verification Information</h4>
                <div className=''>
                    <ul>
                        <li>PAN Details</li>
                        <li>Aadhaar Details (where applicable)</li>
                        <li>Photograph / Selfie</li>
                        <li>KYC Documents</li>
                    </ul>
                </div>

                <h4 className=''>Financial Information</h4>
                <div className=''>
                    <ul>
                        <li>Bank Account Details</li>
                        <li>Income Information</li>
                        <li>Employment Information</li>
                        <li>Loan Application Details</li>
                    </ul>
                </div>

                <h4 className=''>Technical Information</h4>
                <div className=''>
                    <ul>
                        <li>IP Address</li>
                        <li>Browser Information</li>
                        <li>Device Information</li>
                        <li>Website Usage Data</li>
                        <li>Cookies and Similar Technologies</li>
                    </ul>
                </div>

                <h3 className=''>2. Purpose of Collection</h3>
                <p>We may use your information for:</p>
                <div className=''>
                    <ul>
                        <li>Processing loan applications</li>
                        <li>Customer verification and KYC requirements</li>
                        <li>Credit assessment and risk evaluation</li>
                        <li>Customer communication and support</li>
                        <li>Fraud prevention and security monitoring</li>
                        <li>Regulatory and legal compliance</li>
                        <li>Improving website functionality and customer experience</li>
                    </ul>
                </div>

                <h3 className=''>3. Information Sharing</h3>
                <p>Your information may be shared with:</p>
                <div className=''>
                    <ul>
                        <li>Regulatory authorities where required by law</li>
                        <li>Service providers engaged for verification, technology, analytics, or customer support services</li>
                        <li>Credit bureaus, verification agencies, or other authorized entities</li>
                        <li>Group companies, affiliates, or business partners where legally permitted</li>
                    </ul>
                </div>
                <p className='pt-3'>We do not sell customer personal information to third parties.</p>

                <h3 className=''>4. Data Security</h3>
                <p>We maintain reasonable administrative, technical, and physical safeguards to protect customer information against unauthorized access, disclosure, alteration, or misuse.</p>
                <p className='pt-2'>While we strive to protect your information, no method of electronic transmission or storage can be guaranteed to be completely secure.</p>

                <h3 className=''>5. Cookies</h3>
                <p>Our website may use cookies and similar technologies to:</p>
                <div className=''>
                    <ul>
                        <li>Improve website performance</li>
                        <li>Understand user preferences</li>
                        <li>Enhance customer experience</li>
                        <li>Analyze website traffic</li>
                    </ul>
                </div>
                <p className='pt-3'>Users may choose to disable cookies through their browser settings.</p>

                <h3 className=''>6. Customer Consent</h3>
                <p>By submitting information through the Platform, you provide consent for the collection, processing, verification, storage, and use of such information for the purposes outlined in this Privacy Policy and applicable lending processes.</p>
                <p className='pt-2'>Where required, additional consent may be obtained before processing specific categories of information.</p>

                <h3 className=''>7. Data Retention</h3>
                <p>We retain customer information for as long as necessary to fulfill legal, regulatory, business, and operational requirements, or as otherwise required under applicable laws.</p>

                <h3 className=''>8. Third-Party Websites</h3>
                <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices, content, or policies of such external websites.</p>
                <p className='pt-2'>Users are encouraged to review the privacy policies of any third-party websites they visit.</p>

                <h3 className=''>9. Updates to this Privacy Policy</h3>
                <p>The Company reserves the right to update or modify this Privacy Policy from time to time.</p>
                <p className='pt-2'>Any changes will be published on this page with the updated revision date.</p>

                <h3 className=''>10. Contact Us</h3>
                <p>For questions, concerns, or requests relating to this Privacy Policy, please contact:</p>
                <hr style={{ marginTop: '30px', marginBottom: '30px' }} />
                <p className='fw-medium pb-3'>
                    <strong>Surya Jyoti Leasing and Finance Limited</strong>
                </p>
                <p style={{ fontSize: '16px', lineHeight: '30px' }}>
                    <LocationPinIcon className='ms-text-secondary' style={{ marginRight: '10px' }} />
                    <strong>Registered Office:</strong> 407-408, B-08, ITL Tower, Netaji Subhash Place, Pitampura, New Delhi, Delhi 110034<br />
                    <MailIcon className='ms-text-secondary' style={{ marginRight: '10px' }} /> 
                    <strong>Email:</strong> <a href='mailto:care@snaprupee.in'>care@snaprupee.in</a><br />
                    <CallIcon className='ms-text-secondary' style={{ marginRight: '10px' }} /> 
                    <strong>Phone:</strong> 7827277927<br />
                    <PersonAddAltIcon className='ms-text-secondary' style={{ marginRight: '10px' }} /> 
                    <strong>Grievance Officer:</strong> Pooja<br />
                    <MailIcon className='ms-text-secondary' style={{ marginRight: '10px' }} /> 
                    <strong>Grievance Email:</strong> <a href='mailto:grievance@snaprupee.in'>grievance@snaprupee.in</a>
                </p>
                <hr style={{ marginTop: '30px', marginBottom: '30px' }} />
                <p className='pb-5'>By using the Platform, you acknowledge that you have read, understood, and agreed to this Privacy Policy.</p>
            </div>
          
        </>
    )
}
